import React, {Component} from 'react';
import { Row, Col} from 'reactstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { imgStoragePath } from '../../../constants';
import { Link } from 'react-router';
export default class BillingFilter extends Component{
  constructor(props) {
    super(props);
    this.state = {
      filterOpen: true,
      dropDownOpen : false,
      filterSelected : false,
      selectedFilterTitle: ''
    };

    this.displayFilter = {
      'display':'block'
    };
    this.hideFilter = {
      'display':'none'
    };
    this.displaySelectedBlock = {
      'display':'block'
    };
    this.hideSlelectedBlock = {
      'display':'none'
    };
    // this.changeFilter = this.changeFilter.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
    this.updateSlectedItem = this.updateSlectedItem.bind(this);
  }
  handleDownClick = (e) => {
    if (this.node.contains(e.target)) {
      return;
    }else{
    }

  }
  componentWillMount() {
    document.addEventListener('mousedown', this.handleDownClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDownClick, false);
  }

//   changeFilter(selectionOption, type, valueKey) {
//     this.props.updateFilter(selectionOption? selectionOption[valueKey]: '', type);
//   }

  toggleFilter(){
    this.setState(prevState => ({
      ...prevState,
      dropDownOpen : !prevState.dropDownOpen
    }));
  }
  updateSlectedItem(value){
    if(value){
      this.setState(prevState => ({
        ...prevState,
        selectedFilterTitle: value,
        filterSelected : !prevState.filterSelected,
        dropDownOpen : !prevState.dropDownOpen
      }));
    }else{
      this.setState(prevState => ({
        ...prevState,
        filterSelected : !prevState.filterSelected
      }));
    }
  }
  onChange = date => this.setState({ date })
  render(){
    const filterMenu = {
      'Aircraft Type': {
        'inputType': 'dropdown',
        'keyParam': 'aircraft_type',
        'placeholder': 'Select Aircraft Type',
        'options': "",
        'labelKey': 'name',
        'valueKey': 'id',
      },
      'Asset Type': {
        'inputType': 'dropdown',
        'keyParam': 'asset_type',
        'placeholder': 'Select Asset Type',
        'options': [{id: 1, name: 'Aircraft'}, {id: 2, name: 'Engine'}],
        'labelKey': 'name',
        'valueKey': 'id',
      },
      'Engine Type': {
        'inputType': 'dropdown',
        'keyParam': 'engine_type',
        'placeholder': 'Select Engine Type',
        'options': "",
        'labelKey': 'name',
        'valueKey': 'id',
      },
      'Lessee': {
        'inputType': 'dropdown',
        'keyParam': 'lessee',
        'listType': 'lessee',
        'placeholder': 'Select Lessee',
        'labelKey': 'name',
        'valueKey': 'slug',
        'options': ""
      },
      'Serial Number': {
        'inputType': 'text',
        'keyParam': 'serial_number'
      },
      'Status': {
        'inputType': 'dropdown',
        'keyParam': 'status',
        'placeholder': 'Select Status',
        'labelKey': 'label',
        'valueKey': 'value',
        'options': [{label: 'On Lease', value: '1'}, {label: 'Off Lease', value: '2'}, {label: 'On Ground', value: '3'}, {label: 'Written Off / Sold', value: '4'}]
      },
      'Registration Number': {
        'inputType': 'text',
        'keyParam': 'registration'
      },
      'Application' : {
        'inputType': 'dropdown',
        'keyParam': 'application',
        'placeholder': 'Select Application',
        'labelKey': 'name',
        'valueKey': 'id',
        'options':  [{id: 3, name: 'Contracts'}, {id: 6, name: 'Records'}, {id: 2, name: 'Maintenance'}]
      }
    };


    return(
      <div className="asset-list-filter-sort">
        <Row className="add-filter-type" style={{ display : 'none' }}>
          <Col md="10">
            <div className="add-filter">
              <p onClick = { this.toggleFilter} style={{fontSize:"12px"}}>
                <span>
                  { this.state.dropDownOpen ? <img className="close-block" src={imgStoragePath+"black_close.png"} alt="close"/> : <img className="plus-icon" src={imgStoragePath+"black_plus.png"} alt="img" width="10"/> }
                  {this.state.dropDownOpen ?  ' Close Filter': ' Add a Filter'}
                </span>
              </p>
              {/* {Object.keys(filterData).length ? <AssetAppliedFilter />:null} */}
              <ul ref={node => this.node = node} className="list-unstyled filter-list" style={this.state.dropDownOpen ? this.displayFilter : this.hideFilter}>
                {Object.keys(filterMenu).map((menu, index) =>
                  <li onClick={() => {this.updateSlectedItem(menu)}} key={index} className="para-ui th-highlight">{menu}</li>
                )}
              </ul>
              <div className="match-block" style={this.state.filterSelected ? this.displaySelectedBlock : this.hideSlelectedBlock}>
                <div className="match-header">
                  <h4>
                    {this.state.selectedFilterTitle}
                    <span onClick={() => {this.updateSlectedItem('')}}><img width="13" src={imgStoragePath+"white_close.png"}  alt="img"/></span>
                  </h4>
                </div>
                {/* {this.state.selectedFilterTitle?<AssetFilterField updateSlectedItem={this.updateSlectedItem} fieldObj={filterMenu[this.state.selectedFilterTitle]} />:null} */}
              </div>
            </div>
          </Col>
          <Col md="2">
                <a href="javascript:void(0)" className="clear-filter">Clear Filters</a>
          </Col>
        </Row>
        <Row className="filter-block">
          <Col xs="3" md="3" >
            <h6>
                Date
            </h6>
          </Col>

          <Col xs="3" md="3">
            <h6>
              <span>
                Description
              </span>
            </h6>
          </Col>
          <Col xs="3" md="3">
            <h6>
              <span >
                Amount
              </span>
            </h6>
          </Col>
          <Col xs="3" md="3">
            <h6>
              <span>

              </span>
            </h6>
          </Col>
        </Row>
      </div>
    );
  }
}
